import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import LogoutIcon from "@mui/icons-material/Logout";
import PlaceIcon from "@mui/icons-material/Place";
import PersonIcon from "@mui/icons-material/Person";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi";
import logo from "../assets/logo.jpeg";

import { addAmin, selectAdmin } from "../redux/adminSlice";
import { logout } from "../redux/authSlice";
import { groupLogout } from "../redux/businessSlice";
import { edgePositionLogout } from "../redux/edgesPositionedSlice";
import { edgesSliceLogout } from "../redux/edgesSlice";
import { nodePositionlogout } from "../redux/nodePositionedSlice";
import { nodelogout } from "../redux/nodesSlice";
import { selectedNodeLogout } from "../redux/selectedNodesSlice";
import { userLogout } from "../redux/usersSlice";
import { adminLogout } from "../api/apiAdmin";
import { buttonStyle, listItemStyle } from "./SideNavStyles";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";

const drawerWidth = 210;

function SideNav(props) {
  const { window } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const admin = useSelector(selectAdmin);
  const location = useLocation();
  
  const listItemData = [
    {
      label: "Ultimate Holding Company",
      link: `/admin/UltimateHoldingCompany`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    {
      label: "Group Companies",
      link: `/admin/GroupCompanies`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    {
      label: "Business Branches",
      link: `/admin/branches`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    admin?.userRole === "Admin" && {
      label: "Business Groups",
      link: `/admin/groupbusinesses`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    {
      label: "Map View",
      link: `/admin/orgmap`,
      icon: <PlaceIcon style={{ fontSize: "20px" }} />,
    },
    {
      label: "Organisational Chart",
      link: `/admin/Organisational-Chart`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    // {
    //   label: "Lazily Render Nodes",
    //   link: `/admin/lazily-render-nodes`,
    //   icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    // },
    {
      label: "Statistics",
      link: `/admin/stats`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    admin?.permissions?.showUser && {
      label: "Users",
      link: `/admin/userList`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    admin?.userRole === "Admin" && {
      label: "History",
      link: `/admin/History`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    {
      label: "Generate Report",
      link: `/admin/Organisational-Chart?report-generating=true`,
      icon: <HiOutlineUsers style={{ fontSize: "20px" }} />,
    },
    {
      label: "Profile",
      link: `/admin/profile`,
      icon: <PersonIcon style={{ fontSize: "20px" }} />,
    },
  ].filter(Boolean); // remove false items if permission is missing

  const handleLogout = async () => {
    await adminLogout();
    localStorage.removeItem("lsh-token");
    dispatch(addAmin(null));
    dispatch(logout());
    dispatch(groupLogout());
    dispatch(edgePositionLogout());
    dispatch(edgesSliceLogout());
    dispatch(nodePositionlogout());
    dispatch(nodelogout());
    dispatch(selectedNodeLogout());
    dispatch(userLogout());
    navigate("/");
  };

  const drawer = (
    <div
      style={{
        backgroundColor: "#002855",
        height: "100%",
        borderRadius: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Logo */}
      <div
        style={{
          width: "100%",
          zIndex: 900,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem 0",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "60%",
            width: "80px",
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            overflow: "hidden",
            marginBottom: "0.5rem",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ maxWidth: "70%", height: "auto" }}
          />
        </div>

        <Tooltip title="LEI SHING HONG GROUP" arrow placement="right">
          <h2
            style={{
              color: "#FFFFFF",
              fontSize: "1.25rem",
              margin: "0",
              fontWeight: 600,
              letterSpacing: "1px",
              marginTop: "10px",
            }}
          >
            LSH Group
          </h2>
        </Tooltip>

        {/* White horizontal line */}
        <hr
          style={{
            width: "100%",
            border: "none",
            borderTop: "3px solid #FFFFFF",
            marginTop: "0.75rem",
            marginBottom: "0rem",
            backgroundColor: "#FFFFFF",
          }}
        />
      </div>

      {/* Scrollable List */}
      <div style={{ flex: 1, overflowY: "auto", padding: "0 0.5rem" }}>
        <List>
          {listItemData?.map((value, i) => (
            <div key={i} className="rounded-start">
              <RenderItem
                value={value}
                i={i}
                admin={admin}
                location={location}
              />
            </div>
          ))}
        </List>
      </div>

      {/* Logout Button */}
      <div
        style={{ display: "flex", justifyContent: "center", padding: "1rem 0" }}
      >
        <List
          className="cursor-pointer-custom rounded text-center"
          style={{
            backgroundColor: "#f4f4f9",
            width: "90%",
          }}
        >
          <ListItem
            disablePadding
            style={{ cursor: "pointer" }}
            onClick={handleLogout}
          >
            <ListItemText
              className="cursor-pointer-custom d-flex justify-content-center gap-2 px-3"
              primary={
                <Typography
                  variant="body2"
                  style={{
                    fontSize: 14,
                    color: "black",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: "bold",
                  }}
                >
                  <LogoutIcon fontSize="small" />
                  Logout
                </Typography>
              }
            />
          </ListItem>
        </List>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{
        width: { md: drawerWidth },
        flexShrink: { md: 0 },
        bgcolor: "black",
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        container={container}
        variant="temporary"
        open={props.mobileOpen}
        onClose={props.handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            bgcolor: "#FFFFFF",
            color: "#AFB7BE",
            zIndex: { md: 900, xs: 900 },
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            bgcolor: "black",
            border: 0,
            color: "#AFB7BE",
            width: drawerWidth,
            zIndex: { md: 900, xs: 900 },
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}

SideNav.propTypes = {
  window: PropTypes.func,
};

export default SideNav;

const RenderItem = ({ value, i, admin, location }) => {
  const navigate = useNavigate();
  const fullPath = location.pathname + location.search;
  const isActive = fullPath === value.link;

  const handleClick = () => {
    if (value.link) {
      navigate(value.link);
    }
  };

  return value?.link ? (
    <ListItem
      key={i}
      onClick={handleClick}
      disablePadding
      sx={{
        ...listItemStyle,
        backgroundColor: isActive ? "rgb(244, 244, 249)" : "transparent",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      className="rounded"
    >
      <ListItemButton className="list-item list_text" sx={buttonStyle}>
        <ListItemText
          primary={
            <Typography
              variant="body2"
              style={{
                fontSize: 14,
                color: isActive ? "#002855" : "white",
                paddingLeft: 0,
                fontWeight: isActive ? "bold" : "normal",
              }}
              title={value?.label}
            >
              {value?.label}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  ) : null;
};
